import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_LOCALE, LOCALE_TO_OG, SUPPORTED_LOCALES, type SupportedLocale, buildAlternateUrl } from "@/utils/geo";

// Injects hreflang alternates and OG locale meta tags for geo-optimization
const Hreflang = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname || "/";

    // Clean previous managed tags
    document.querySelectorAll('link[rel="alternate"][data-hreflang-managed="true"]').forEach((el) => el.remove());
    document.querySelectorAll('meta[data-hreflang-managed="true"]').forEach((el) => el.remove());

    // Add hreflang alternates
    const locales: SupportedLocale[] = [...SUPPORTED_LOCALES];

    const addAlt = (hreflang: string, href: string) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hreflang);
      link.setAttribute("href", href);
      link.setAttribute("data-hreflang-managed", "true");
      document.head.appendChild(link);
    };

    // x-default points to default locale
    addAlt("x-default", buildAlternateUrl(pathname, DEFAULT_LOCALE));
    locales.forEach((loc) => addAlt(loc, buildAlternateUrl(pathname, loc)));

    // Add OG locale tags
    const addMeta = (property: string, content: string) => {
      const meta = document.createElement("meta");
      meta.setAttribute("property", property);
      meta.setAttribute("content", content);
      meta.setAttribute("data-hreflang-managed", "true");
      document.head.appendChild(meta);
    };

    addMeta("og:locale", LOCALE_TO_OG(DEFAULT_LOCALE));
    locales
      .filter((l) => l !== DEFAULT_LOCALE)
      .forEach((l) => addMeta("og:locale:alternate", LOCALE_TO_OG(l)));

    // Content language meta (helps some crawlers)
    const langMeta = document.createElement("meta");
    langMeta.setAttribute("http-equiv", "content-language");
    langMeta.setAttribute("content", DEFAULT_LOCALE);
    langMeta.setAttribute("data-hreflang-managed", "true");
    document.head.appendChild(langMeta);
  }, [location.pathname]);

  return null;
};

export default Hreflang;
